/**
 * accountDeletion.js — hesap silme "grace period" (bekleme suresi) icin TEK
 * KAYNAK. LanguageContext.js icindeki 7 TR + 7 EN metin anahtari bu sabitten
 * turer (bkz. profile.deleteAccount.* ve accountDeletion.* anahtarlari).
 *
 * ⚠️ BU DEGER BACKEND'TEKI GERCEK SABITE BAGLIDIR AMA OTOMATIK TURETILEMEZ:
 * backend/services/account_deactivation.py:80 -> USER_DELETION_GRACE_HOURS = 72
 * (saat cinsinden). Web ve backend ayri repo/derleme adimlarinda calistigi
 * icin bu degeri build-time'da backend kaynagindan okuyacak bir mekanizma
 * YOK — burada ELLE senkron tutulan bir kopyadir (72 saat / 24 = 3 gun).
 *
 * Backend'teki USER_DELETION_GRACE_HOURS degisirse bu dosya da ELLE
 * guncellenmelidir; aksi halde web metinleri (LanguageContext.js) gercek
 * bekleme suresinden farkli bir rakam soyler.
 */
export const ACCOUNT_DELETION_GRACE_DAYS = 3;
